import React from 'react';

const links = [
  {
    href: '/resume',
    label: 'Resume',
    description: 'Experience, skills, and background',
  },
  {
    href: '/blog/',
    label: 'Blog',
    description: 'Notes on agents and infrastructure',
  },
];

function Hub() {
  return (
    <div className="hub">
      <div className="hub-container">
        <header className="hub-header">
          <h1 className="hub-name">Yousef Nassar</h1>
          <p className="hub-tagline">Software engineer, builder, and occasional writer.</p>
        </header>

        <nav className="hub-links">
          {links.map((link) => (
            <a key={link.href} className="hub-link" href={link.href}>
              <span className="hub-link-label">{link.label}</span>
              <span className="hub-link-description">{link.description}</span>
            </a>
          ))}
        </nav>
      </div>

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .hub {
          min-height: 100vh;
          background: #fafafa;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'SF Pro Text', sans-serif;
          color: #1d1d1f;
          display: flex;
          align-items: center;
          justify-content: center;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .hub-container {
          max-width: 480px;
          width: 100%;
          padding: 48px 32px;
        }

        .hub-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .hub-name {
          font-size: 40px;
          font-weight: 600;
          letter-spacing: -1px;
          margin-bottom: 12px;
        }

        .hub-tagline {
          font-size: 16px;
          color: #86868b;
        }

        .hub-links {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .hub-link {
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding: 20px 24px;
          border: 1px solid #e5e5e7;
          border-radius: 12px;
          text-decoration: none;
          transition: border-color 0.2s ease, transform 0.2s ease;
        }

        .hub-link:hover {
          border-color: #0066cc;
          transform: translateY(-1px);
        }

        .hub-link-label {
          font-size: 17px;
          font-weight: 500;
          color: #1d1d1f;
        }

        .hub-link-description {
          font-size: 14px;
          color: #86868b;
        }
      `}</style>
    </div>
  );
}

export default Hub;
